















































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import user_Username from '../user/Username.vue';
import coderofthemonth_CodersList from './CodersList.vue';
import coderofthemonth_TopCodersList from './TopCodersList.vue';
import coderofthemonth_CandidatesList from './CandidatesList.vue';
import country_Flag from '../CountryFlag.vue';
import { types } from '../../api_types';

@Component({
  components: {
    'omegaup-user-username': user_Username,
    'omegaup-countryflag': country_Flag,
    'omegaup-coders-list': coderofthemonth_CodersList,
    'omegaup-top-coders-list': coderofthemonth_TopCodersList,
    'omegaup-candidates-list': coderofthemonth_CandidatesList,
  },
})
export default class CoderOfTheMonthList extends Vue {
  @Prop() codersOfCurrentMonth!: types.CoderOfTheMonthList[];
  @Prop() codersOfPreviousMonth!: types.CoderOfTheMonthList[];
  @Prop() candidatesToCoderOfTheMonth!: types.CoderOfTheMonthList[];
  @Prop() canChooseCoder!: boolean;
  @Prop() coderIsSelected!: boolean;
  @Prop() isMentor!: boolean;
  @Prop() category!: string;
  @Prop() selectedTab!: string;

  T = T;
  currentSelectedTab = this.selectedTab;

  get availableTabs(): { id: string; component: string; title: string }[] {
    const availableTabs = [
      {
        id: 'codersOfTheMonth',
        component: 'omegaup-coders-list',
        title:
          this.category === 'all'
            ? T.codersOfTheMonth
            : T.codersOfTheMonthFemale,
      },
      {
        id: 'codersOfPreviousMonth',
        component: 'omegaup-top-coders-list',
        title:
          this.category === 'all'
            ? T.codersOfTheMonthRank
            : T.codersOfTheMonthFemaleRank,
      },
      {
        id: 'candidatesToCoderOfTheMonth',
        component: 'omegaup-candidates-list',
        title:
          this.category === 'all'
            ? T.codersOfTheMonthListCandidate
            : T.codersOfTheMonthFemaleListCandidate,
      },
    ];

    return availableTabs;
  }

  get visibleCoders(): types.CoderOfTheMonthList[] {
    switch (this.currentSelectedTab) {
      case 'codersOfTheMonth':
      default:
        return this.codersOfCurrentMonth;
      case 'codersOfPreviousMonth':
        return this.codersOfPreviousMonth;
      case 'candidatesToCoderOfTheMonth':
        return this.candidatesToCoderOfTheMonth;
    }
  }

  get currentTabComponent(): string {
    return (
      this.availableTabs.find((tab) => tab.id === this.currentSelectedTab)
        ?.component ?? 'codersOfTheMonth'
    );
  }

  getSelectedTab(tab: { id: string; component: string; title: string }): void {
    this.currentSelectedTab = tab.id;
    window.location.hash = tab.id;
  }

  getTabName(tab: { id: string; component: string; title: string }): string {
    return `#${tab.id}`;
  }
}
